import React from 'react';
import { Checkbox as BaseCheckbox } from 'semantic-ui-react';

export default function Checkbox({ handleClick, checked }) {
  return (
    <button onClick={handleClick}>
      <BaseCheckbox
        className={'large'}
        checked={checked}
        name="selectAll"
        onClick={handleClick}
      />
    </button>
  );
}



// WEBPACK FOOTER //
// ./src/component/TasksManagerList/Checkbox.js